import { t } from "@lingui/macro";

import { ClubLogo } from "@/components/ClubLogo/ClubLogo";
import { ClubLogo_Club$key } from "@/components/ClubLogo/__generated__/ClubLogo_Club.graphql";
import { Button } from "@whoosh/design-system/src/components/controls";
import { CloseIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import { StandardModal } from "@whoosh/design-system/src/components/overlay/StandardModal";
import {
  Box,
  HStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import {
  NewPatronEventsSidebar,
  NewPatronEventsSidebarProps,
} from "./NewPatronEventsSidebar/NewPatronEventsSidebar";

type Props = NewPatronEventsSidebarProps & {
  isOpen: boolean;
  onClose: () => void;
  clubRef: ClubLogo_Club$key | null;
};

export const EventsFilterModal = ({
  isOpen,
  onClose,
  clubRef,
  ...props
}: Props) => {
  return (
    <StandardModal
      upperNode={
        <HStack justifyContent="space-between" alignItems="center" flexGrow={1}>
          <Button
            testID="modal-close-btn"
            accessibilityLabel={t`Close button`}
            variant="secondary"
            onPress={() => {
              onClose?.();
            }}
            leftIcon={<CloseIcon />}
          />
          <Text variant="mainBaseSemiBold">{t`Filters`}</Text>
          <ClubLogo clubRef={clubRef} />
        </HStack>
      }
      hideCloseButton={true}
      subtitle={t`Filters`}
      isOpen={isOpen}
      onClose={onClose}
      disableContentScroll={false}
      content={
        <Box flex={1} pt={6} height="100%" testID="events-filter-modal-content">
          <NewPatronEventsSidebar {...props} />
        </Box>
      }
    />
  );
};
